export default "__VITE_ASSET__CMpqEnGZ__"